import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

/**
 * Magic-link sign-in lands on `/login?magic-link=…` with no email. It must reach the magic-link
 * guard intact: on the server that guard defers to the browser, so redirecting here would drop the
 * token and break the link.
 */
const MAGIC_LINK_PARAM = 'magic-link';

/**
 * The login page only asks for the password — the email comes from `?email=` set by the welcome
 * step. Without it the login request cannot succeed and the password manager has no username to
 * pair the password with, so send the visitor back to the email step (keeping other params, e.g. UTM).
 */
export const loginEmailGuard: CanActivateFn = route => {
  const { queryParamMap } = route;

  if (queryParamMap.get('email') || queryParamMap.has(MAGIC_LINK_PARAM)) {
    return true;
  }

  return inject(Router).createUrlTree(['/welcome'], { queryParams: route.queryParams });
};
